import _typeof from "@babel/runtime/helpers/esm/typeof";
var globals = {
  self: typeof self !== 'undefined' && self,
  window: typeof window !== 'undefined' && window,
  global: typeof global !== 'undefined' && global,
  document: typeof document !== 'undefined' && document,
  process: (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process
};
var self_ = globals.self || globals.window || globals.global;
var window_ = globals.window || globals.self || globals.global;
var global_ = globals.global || globals.self || globals.window;
var document_ = globals.document || {};
var process_ = globals.process || {};
var console_ = console;
export { self_ as self, window_ as window, global_ as global, document_ as document, process_ as process, console_ as console };
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/probe.gl/dist/esm/env/globals.js
// module id = 266
// module chunks = 0